

















































































































































































































































import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { Emit, Prop, Provide, Watch } from "vue-property-decorator";
import { MenuItem, SubMenu } from "@/types";
import VueRouter, { Route } from "vue-router";
import Cookies from "js-cookie";
import { ShowSnackbar } from "@/store/modules/showSnackbar/types";
import { State } from "vuex-class";
import AxiosMixin from "../../mixins/axiosMixin";

@Component
export default class Main extends mixins(AxiosMixin) {
  @State("showsnackbar") snack!: ShowSnackbar;

  @Prop({ default: false }) readonly opelogEnabled!: boolean;

  private showFlag = false;

  private menuItems: MenuItem[] = [
    {
      id: 0,
      icon: "mdi-table-account",
      url: "/medical/transmission",
      name: "医療請求管理 (新：電子/紙)",
      items: [
        {
          id: 1,
          icon: "mdi-table-account",
          url: "/medical/return",
          name: "返戻管理"
        }
      ],
      showSubMenu: false
    },
    {
      id: 2,
      icon: "mdi-table-account",
      url: "/medical/merge",
      name: "医療請求管理 (旧：紙)",
      items: [],
      showSubMenu: false
    },
    {
      id: 3,
      icon: "mdi-table-account",
      url: "/medical/summarytable",
      name: "総括表管理",
      items: [],
      showSubMenu: false
    },
    {
      id: 4,
      icon: "mdi-table-account",
      url: "/care/merge",
      name: "介護請求管理",
      items: [],
      showSubMenu: false
    },
    {
      id: 5,
      icon: "mdi-file-send-outline",
      url: "/care/transmission",
      name: "介護請求伝送",
      items: [],
      showSubMenu: false
    },
    {
      id: 6,
      icon: "mdi-table-account",
      url: "/userinvoice?only=false",
      name: "利用者請求管理",
      items: [],
      showSubMenu: false
    }
  ];

  private innerReceiptDashboardMenuItems: MenuItem[] = [
    {
      id: 8,
      icon: "mdi-format-list-bulleted",
      url: "/billinglist",
      name: "請求一覧",
      items: [],
      showSubMenu: false
    },
    {
      id: 9,
      icon: "mdi-format-list-bulleted",
      url: "/billinglistdetails",
      name: "請求一覧（詳細）",
      items: [],
      showSubMenu: false
    },
    {
      id: 10,
      icon: "mdi-format-list-bulleted",
      url: "/account_transfer",
      name: "口座振替データ管理",
      classes: ["account-transfer-manage-menu-label"],
      items: [],
      showSubMenu: false
    },
    {
      id: 91,
      icon: "mdi-format-list-bulleted",
      url: "/billinglistdetailsprintedat",
      name: "請求一覧（詳細/処理済月）",
      items: [],
      showSubMenu: false
    }
  ];

  private innerSettingItems: MenuItem[] = [
    {
      id: 11,
      icon: "mdi-wallet-travel",
      url: "/payment_manage",
      name: "入金管理",
      items: [],
      showSubMenu: false
    },
    {
      id: 12,
      icon: "mdi-message-alert-outline",
      url: "/all_no_output",
      name: "未処理データ一覧",
      items: [],
      showSubMenu: false
    },
    {
      id: 14,
      icon: "mdi-history",
      url: "/operation_log",
      name: "ログ",
      items: [],
      showSubMenu: false
    },
    {
      id: 13,
      icon: "mdi-cog-outline",
      url: "/settings",
      name: "設定",
      items: [],
      showSubMenu: false
    }
  ];

  private drawer = true;

  private menuActive = 0;

  private userInvoiceActive = true;

  private receiptDashboardActive = true;

  private office_name = window.office_name;

  private user_name = window.user_name;

  private mode = window.mode;

  private auth_id = window.auth_id;

  private title_text = "";

  private isTrial = window.is_trial;

  @Provide() navigationManage = this.setMenuActive;

  mounted() {
    this.getShowFlag();
    this.setMenuActive();
  }

  @Watch("$route")
  handleRoute(before: Route, after: Route) {
    if (before.path !== after.path) {
      this.setMenuActive();
    }
  }

  //介護請求伝送メニュー表示判定
  private getShowFlag() {
    this.postJsonCheck(
      window.base_url + "/api/office/menu_show_flag/get",
      {},
      res => {
        this.showFlag = res.data.menu_show_flag;
      }
    );
  }

  private showMenu(item: MenuItem) {
    // 伝送のみ表示・非表示の判定必要
    if (item.url === "/care/transmission") {
      return this.showFlag;
    }
    if (item.url === "/operation_log") {
      return this.opelogEnabled;
    }
    return true;
  }

  private get receiptDashboardMenuItems(): MenuItem[] {
    return this.innerReceiptDashboardMenuItems;
  }

  private get settingItems(): MenuItem[] {
    return this.innerSettingItems;
  }

  private setMenuActive() {
    const url = window.location.href;
    const results = url.match(/^https?:\/\/.*?(\/[^?]*).*/);
    if (results && results.length > 1) {
      let hit = false;
      const path = results[1];
      const activeItem = this.menuItems.find(item => item.showSubMenu);
      this.menuItems.forEach(item => {
        if (path === item.url.replace("?only=false", "")) {
          this.userInvoiceActive = false;
          this.receiptDashboardActive = false;
          this.menuActive = item.id;
          this.title_text = item.name;
          hit = true;

          // 現在アクティブなメニューと別メニューの場合、非アクティブにする（アコーディオンを閉じる）
          if (activeItem && activeItem.id != item.id) {
            activeItem.showSubMenu = false;
          }
          item.showSubMenu = true;
        } else if (item.items.length > 0) {
          //サブメニューが存在する場合
          item.items.forEach(sub => {
            if (path === sub.url.replace("?only=false", "")) {
              this.userInvoiceActive = false;
              this.receiptDashboardActive = false;
              this.menuActive = sub.id;
              this.title_text = item.name + " | " + sub.name;
              hit = true;

              // 現在アクティブなメニューと別メニューの場合、非アクティブにする（アコーディオンを閉じる）
              if (activeItem && activeItem.id != item.id) {
                activeItem.showSubMenu = false;
              }
              item.showSubMenu = true;
            }
          });
        }
      });
      if (!hit) {
        this.receiptDashboardMenuItems.forEach(item => {
          if (path === item.url.replace("?only=false", "")) {
            this.userInvoiceActive = false;
            this.receiptDashboardActive = true;
            this.menuActive = item.id;
            this.title_text = "レセプトダッシュボード | " + item.name;
            hit = true;
          }
        });
      }
      if (!hit) {
        this.settingItems.forEach(item => {
          if (path === item.url) {
            this.userInvoiceActive = false;
            this.receiptDashboardActive = false;
            this.menuActive = item.id;
            this.title_text = item.name;
            hit = true;
          }
        });
      }
    }
  }

  private linkto(item: MenuItem | SubMenu) {
    this.$router.push(item.url);
  }

  private clickChangeOfficeBtn() {
    this.selectOff();
  }

  /**
   * ログインユーザーの権限が本社職員以上の場合true返却
   */
  private checkAuth() {
    return this.auth_id == 20 || this.auth_id == 99;
  }

  private logout() {
    window.token = "";
    //レセプト用のトークンはcookieに記憶しない
    // Cookies.set("token", "");
    window.reftoken = "";
    //レセプト用のトークンはcookieに記憶しない
    // Cookies.set("reftoken", "");
    window.office_name = "";
    Cookies.set("office_name", "");
    window.office_id = 0;
    Cookies.set("office_id", "");
    Cookies.set("isAgree", "");
    localStorage.removeItem("yearmonth");
    localStorage.removeItem("yearmonths");
    location.href = "/";
    window.close();
  }

  @Emit("selectOff")
  private selectOff() {
    return;
  }
}
